import { mount } from "@vue/test-utils";
import BranchOffices from "@/components/core/custom/BranchOffices";

jest.mock("@/components/core/custom/BranchOffices", () => ({
  default: {
    latitude: {}
  }
}));

describe("BranchOffices test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(BranchOffices);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component BranchOffices", () => {
    expect(wrapper).toBeDefined();
  });
});
